module.exports = __webpack_public_path__ + "static/media/iphone-mask-360.51bbdd2e.png";